<script lang="ts" setup>
interface GwColorItemProps {
  item: string
  tstPrefix?: string
}

const props = withDefaults(defineProps<GwColorItemProps>(), {
  tstPrefix: 'item',
})
</script>
<template>
  <div
    class="gw_color_item"
    :style="`background-color: ${item}`"
    :data-tst="`${tstPrefix}_coloritem_${item}`"
  ></div>
</template>
<style lang="scss" scoped>
.gw_color_item {
  border-radius: 4px;
  height: 1.25rem;
  width: 1.25rem;
}
</style>
